<template>
  <div class="home">
    <header class="header">
      <div class="nav-header">
        <div class="title">
          <img class="logo" src="../../assets/logo.png" alt="logo" @click="router.push('/index')" />
          <!-- <div v-if="!isMobile">湖北日报传媒集团招聘系统</div> -->
        </div>

        <div v-if="userInfo && userInfo.userName" style="display: flex">
          <div class="user">
            <span class="user_name">{{ userInfo.userName }}</span>
          </div>
          <div v-if="!isMobile" class="exit" @click="logout">退出</div>
        </div>
        <Expand v-if="isMobile" class="menuIcon" :class="{ show: expand }" @click="showMenu" />
      </div>
    </header>

    <main class="main">
      <div v-if="expand && isMobile" class="mask" @click="showMenu"></div>
      <div class="leftMenu" :class="{ show: expand }">
        <div class="menuIn">
          <ul>
            <li
              v-for="(item, index) in nav"
              :key="'nav_' + index"
              v-show="!!item.show"
              :class="{ current: item.index == current }"
              @click="handleMenuClick(item)"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <router-view v-slot="{ Component }">
          <keep-alive>
            <component v-if="route.meta.keepAlive" :is="Component" :key="route.path" />
          </keep-alive>
          <component v-if="!route.meta.keepAlive" :is="Component" :key="route.path" />
        </router-view>
      </div>
    </main>
    <footer class="footer">
      Copyright © 2018-2028
      <a href="https://www.hubeidaily.net">湖北日报传媒集团</a>
      All Rights Reserved 鄂ICP备12007957号 &nbsp; 技术支持：027-88568275
    </footer>
  </div>
  <div v-if="showLogin">
    <login-modal :canRegister="activity?.isInTime" />
  </div>
  <el-dialog
    v-model="dialogVisible"
    title="网上报名指南"
    :width="isMobile ? '90%' : 660"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    lock-scroll
    custom-class="guide"
  >
    <p>
      1.本次招聘网上注册、报名时间为{{ activity?.startTimeStr }}至{{ activity?.endTimeStr }}。{{
        activity?.endTimeStr
      }}报名窗口准时关闭，请报考人员尽早报名，切勿在临近窗口关闭时操作，避免注册、报名失败。
    </p>
    <br />
    <p>
      2.每名报考人员限报1个岗位，报名信息提交成功后，不可撤回改报其他岗位。请仔细阅读《公告》和《岗位表》，熟悉相关要求，对需要填写的每一项内容认真考虑，慎重填报，严肃对待，如实填写。
    </p>
    <br />
    <p>3.报名时间内，招聘单位每天进行资格审查，报考人员可同步查询审查结果。报名网站显示各岗位报考人数和资格审查通过人数，供报考人员参考。</p>
    <br />
    <p>4.由于需要填写的报名信息较为详细，建议报考人员先将相关内容用文档编辑录入。在网上填写报名表时，将已准备好的资料一一粘贴到表中即可。</p>
    <br />
    <p>5.网上报名技术咨询电话：027-88568275/政策咨询电话：027-88568002</p>
    <br />
    <el-checkbox v-model="checked">我已阅读并知晓</el-checkbox>
    <p>&nbsp;<span class="tips" style="color: red; display: none">请先勾选"我已阅读并知晓"</span></p>
    <div style="text-align: center"><el-button type="primary" @click="onSubmit">确认</el-button></div>
  </el-dialog>
</template>

<script>
import { Expand } from '@element-plus/icons';
import { reactive, toRefs, computed, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import LoginModal from '../../components/Login/Index.vue';
import UserApi from '../../service/api/user';
import { ElMessage } from 'element-plus';
import { needLoginPage } from '../../router';
import ApplicantApi from '../../service/api/applicant';
import { formatDate, compareInDate } from '../../utils/tools';

export default {
  components: { LoginModal, Expand },
  name: 'home',
  setup() {
    const state = reactive({
      expand: false, //移动端下菜单控制展开
      current: 0,
      showAdmission: false,
      activity: null, //activityId 最近的招聘批次id, activityType 最近批次的招聘类型 0普通招聘 1专项招聘
      checked: false,
      dialogVisible: false,
    });
    const store = useStore();
    const showLogin = computed(() => store.state.showLogin);
    const userInfo = computed(() => store.state.userInfo);
    const isMobile = computed(() => store.state.isMobile);
    const nav = computed(() => [
      { name: 'home', title: '返回主页', path: '/index', index: 0, h5: true, show: true },
      { name: 'resume', title: '我的简历', path: '/resume', index: 1, h5: false, show: true },
      { name: 'deliver', title: '审核状态', path: '/deliver', index: 2, h5: true, show: true },
      { name: 'preview', title: '打印报名表', path: '/preview', index: 3, h5: false, show: true },
      { name: 'admission', title: '打印准考证', path: '/admissionTicket', index: 4, h5: false, show: true },
      { name: 'score', title: '笔试成绩', path: '/score', index: 5, h5: true, show: isSpecific.value },
      { name: 'progress', title: isSpecific.value ? '面试确认' : '招聘进度', path: '/progress', index: 6, h5: true, show: true },
    ]);

    const router = useRouter();
    const route = useRoute();

    watch(route, () => navChange());
    const navChange = () => {
      const curPath = nav.value.filter((i) => i.path == route.path);
      state.current = curPath.length ? curPath[0].index : 0;
    };

    const handleMenuClick = (menu) => {
      state.expand = false;
      if (isMobile.value && !menu.h5) {
        return ElMessage.warning('为了更好地体验，请在PC端登录投递');
      }
      if (needLoginPage.includes(menu.path)) {
        if (!userInfo.value || !userInfo.value.userId) {
          return store.commit('SET_SHOWLOGIN', true);
        }
      }
      state.current = menu.index;
      if (menu.path) {
        return router.push(menu.path);
      }
    };

    const getUserInfo = async () => {
      try {
        const res = await UserApi.getUserInfo();
        store.commit('SET_USERINFO', {
          email: res.email,
          userId: res.userId,
          userName: res.userName,
          basicId: res.basicId, // 简历ID
        });
        res.basicId && localStorage.setItem('basicId', res.basicId);
      } catch (e) {
        console.info('未登录', e);
        // 进入简历页需要登录，若误跳直接返回首页
        if (needLoginPage.includes(route.path)) {
          router.push('/index');
        }
      }
    };

    const logout = async () => {
      try {
        await UserApi.logout();
        store.commit('SET_USERINFO', null);
        store.commit('SET_TOKEN', '');
        localStorage.clear();
        ElMessage.success('用户已退出');
        state.showAdmission = false;
        setTimeout(() => location.reload(), 300);
      } catch (e) {
        console.error('logout失败', e);
      }
    };

    const showMenu = () => {
      state.expand = !state.expand;
    };

    const getBatchList = async () => {
      let res = await ApplicantApi.getBatchList({
        pageNum: 1,
        pageSize: 20,
      });
      const batchList = res.list
        .filter((item) => item.status === 1 || item.status === 3 || item.status === 4)
        .map((item) => ({
          ...item,
          startTimeStr: formatDate('YYYY年MM月DD日 hh:mm:ss', new Date(item.startTime)),
          endTimeStr: formatDate('YYYY年MM月DD日 hh:mm:ss', new Date(item.endTime)),
          isInTime: compareInDate(item.startTime, item.endTime) || false,
        }));
      const recentBatch = (batchList && batchList[0]) || null;
      state.activity = recentBatch;
      store.commit('SET_CURRENTBATCH', recentBatch || null);
      if (recentBatch) {
        if (isSpecific.value) {
          // 弹窗网上报名指南
          const guide = localStorage.getItem('guide');
          state.dialogVisible = +guide == 0;
          localStorage.setItem('guide', 0);
        }
      }
    };

    const onSubmit = () => {
      if (state.checked) {
        state.dialogVisible = false;
      }
      document.querySelector('.tips').style.display = 'inline-block';
    };

    onMounted(() => {
      getUserInfo();
      getBatchList();
      navChange();
      ApplicantApi.getConf();
    });

    const isSpecific = computed(() => store.state.isSpecific); //是否是专项招聘
    return {
      ...toRefs(state),
      handleMenuClick,
      logout,
      showMenu,
      route,
      router,
      showLogin,
      userInfo,
      isMobile,
      isSpecific,
      nav,
      onSubmit,
    };
  },
};
</script>

<style scoped lang="scss">
@import '../../style/func.scss';
.home {
  height: 100%;
  background: rgba(246, 246, 246, 0.97);

  .main {
    display: flex;
    max-width: 1400px;
    // max-width: 1200px;
    margin: 0 auto;
    padding-top: rem(60px);
    min-height: calc(100% - rem(50px));
    background: #fff;
    .leftMenu {
      width: 200px;
      background: #ffffff;
      border-right: 1px solid #e6e6e6;
      position: fixed;
      top: rem(60px);
      bottom: rem(50px);
      overflow-y: auto;
      z-index: 999;
      .menuIn {
        padding: 50px 20px;
        ul li {
          width: 142px;
          height: 45px;
          margin: 0 auto 19px auto;
          line-height: 45px;
          position: relative;
          border-radius: 3px;
          box-sizing: border-box;
          list-style: none;
          color: #333;
          font-size: 16px;
          padding-left: 30px;
          cursor: pointer;
          border-bottom: 1px #ededed dashed;
          &.current {
            background: #4784e3;
            border-color: #4784e3;
            color: #fff;
            &:after {
              content: '';
              width: 0;
              height: 0;
              position: absolute;
              top: 12px;
              right: -14px;
              border-top: solid 10px transparent;
              border-left: solid 14px #4784e3;
              border-bottom: solid 10px transparent;
            }
          }
        }
      }
    }
    .right {
      margin-left: 200px;
      width: 100%;
      overflow: hidden;
    }
  }

  .footer {
    text-align: center;
    height: rem(50px);
    line-height: rem(50px);
    // background: #dcdcdc;
    font-size: rem(12px);
    a {
      text-decoration: none;
      &:hover {
        color: #318eef;
      }
    }
  }
}

.header {
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: rem(60px);
  background: white;
  border-bottom: 1px solid #eee;
  color: #333;
  font-size: rem(20px);
  z-index: 10;
  white-space: nowrap;
  overflow-y: hidden;
  .nav-header {
    height: 100%;
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 rem(20px);
  }
  .logo {
    height: 100%;
    margin-right: rem(40px);
  }

  .title {
    height: 60%;
    display: flex;
    align-items: center;
    font-size: rem(19px);
    font-weight: bold;
    cursor: pointer;
  }
  .user {
    margin: 0 rem(20px);
    display: inline-flex;
    align-items: center;
    margin-right: rem(20px);
    font-size: rem(15px);
    color: #707070;
    cursor: pointer;
    &_avatar {
      background: #d9d9d9;
      border-radius: 50%;
      width: rem(40px);
      height: rem(40px);
      margin-right: rem(10px);
    }
  }

  .exit {
    font-size: rem(18px);
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .exit:hover {
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
  }
}

@media screen and (max-width: 600px) {
  .home {
    .header {
      .nav-header {
        padding: 0 rem(10px);
        .title {
          height: 40%;
          .logo {
            margin-right: 0;
          }
        }
      }
      .user {
        margin: 0 rem(10px);
      }
      .menuIcon {
        transition: transform 0.5s;
        width: rem(24px);
        &.show {
          transform: rotate(180deg);
        }
      }
    }
    .main {
      .leftMenu {
        width: rem(200px);
        bottom: 0;
        right: -100%;
        transition: all 0.3s;
        .menuIn {
          padding: rem(10px);
        }
        &.show {
          right: 0;
        }
      }
      .right {
        margin-left: 0;
      }
    }
    .footer {
      height: rem(50px);
      line-height: rem(24px);
      font-size: rem(12px);
    }
  }
  .mask {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>
